import AccessCheck from './AccessCheck';

export default AccessCheck;
